




// scroll-animation start


document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll(".scroll-animation");

    function checkScroll() {
        elements.forEach((element) => {
            const rect = element.getBoundingClientRect();
            if (rect.top < window.innerHeight * 0.85) {
                element.classList.add("visible");
            }
        });
    }

    window.addEventListener("scroll", checkScroll);
    checkScroll(); // Run on load in case elements are already in view
});


// scroll-animation end



// header start

let lastScrollTop = 0;

window.addEventListener('scroll', function () {
    const header = document.querySelector('header');
    const body = document.body;

    const currentScroll = window.scrollY;

    if (currentScroll === 0) {
        // At the top of the page — reset
        header.classList.remove('header-sticky');
        header.style.top = '0';
    } else {
        // Apply sticky class if not already applied
        if (!header.classList.contains('header-sticky')) {
            header.classList.add('header-sticky');
        }

        if (currentScroll < lastScrollTop) {
            // Scrolling up — show header
            header.style.top = '0';
        } else {
            // Scrolling down — hide header
            header.style.top = '-100%';
        }
    }

    lastScrollTop = currentScroll;
});


// header end


// hero start


document.addEventListener("DOMContentLoaded", function () {
    const heroWrap = document.querySelector(".hero__content-wrap");
    heroWrap.classList.add("visible");
});

// hero end



// featured-product start


if ($(Window).width() < 768) {
    $('.featured-product__right-cards').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        slide: '.featured-product__right-card:not(.featured-product__right-card_btn)'
    });
}


// featured-product end



// text-with-marquee start


$(".text-with-marquee__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});



// text-with-marquee end




// made start



$('.made__items').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    // variableWidth: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});



$('.made__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.made__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


// made end





// all-product tab start


// document.querySelectorAll('.all-product__top ul li').forEach(tab => {
//     tab.addEventListener('click', () => {
//         // Remove active class from all tab buttons
//         document.querySelectorAll('.all-product__top ul li').forEach(el => el.classList.remove('active'));
//         tab.classList.add('active');

//         // Get the target tab name
//         const target = tab.getAttribute('data-tab');

//         // Hide all .all-product__items sections
//         document.querySelectorAll('.all-product__items').forEach(item => {
//             item.classList.remove('active');
//         });

//         // Show only the matching .all-product__items
//         const targetItems = document.querySelector(`.all-product__items[data-tab-content="${target}"]`);
//         if (targetItems) {
//             targetItems.classList.add('active');
//         }
//     });
// });





// all-product tab end






// footer accordion start

if ($(Window).width() < 768) {
    $(".footer__item-accordion-title").click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass("active");
            $(this).next(".footer__item-accordion-content").slideUp();
        } else {
            $(".footer__item-accordion-content").slideUp();
            $(".footer__item-accordion-title").removeClass("active");
            $(this).addClass("active");
            $(this).next(".footer__item-accordion-content").slideDown();
        }
    })
}




// footer accordion end



// product slider start


$('.product__big-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    adaptiveHeight: true,
    draggable: false,
    swipe: false,
    asNavFor: '.product__small-items',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});
$('.product__small-items').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.product__big-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    vertical: true,
});


// product slider end



// product accordion start



$(".accordion__title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".accordion__content").slideUp();
    } else {
        $(".accordion__content").slideUp();
        $(".accordion__title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".accordion__content").slideDown();
    }
})


// product accordion end



// review start


$('.review__items').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});


$('.review__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.review__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



// review end



// collection-product start


if ($(Window).width() < 768) {
    $('.collection-product__items').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });
}



// collection-product end



// gallery start


$(".instagram__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});



// gallery end





// journal start

document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll('.journal__item');

    items.forEach((item, index) => {
        const rowIndex = Math.floor(index / 2); // which row it's in
        const positionInRow = index % 2;        // 0 for left, 1 for right

        // Reset any inline style (optional)
        item.style.flex = '';

        // Odd rows: 38.8%, 59.2%
        if (rowIndex % 2 === 0) {
            item.style.flex = positionInRow === 0 ? '1 0 38.8%' : '1 0 59.2%';
        } else { // Even rows: 59.2%, 38.8%
            item.style.flex = positionInRow === 0 ? '1 0 59.2%' : '1 0 38.8%';
        }
    });
});

// journal end



// mega-menu start


if ($(Window).width() < 768) {
    $(".mega-menu__item-title").click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass("active");
            $(this).next(".mega-menu__item-content").slideUp();
        } else {
            $(this).addClass("active");
            $(this).next(".mega-menu__item-content").slideDown();
        }
    });
}


// mega-menu end


// menu start



$(".header__mobi-menu").on('click', function () {
    $("body").toggleClass('menu-active');
})


// for desktop

$(document).ready(function () {
    $('.header__nav-shop , .mega-menu').hover(
        function () {
            if ($(window).width() > 991) { // Adjust breakpoint as needed
                $('body').addClass('mega-menu-show');
            }
        },
        function () {
            if ($(window).width() > 991) {
                $('body').removeClass('mega-menu-show');
            }
        }
    );
});


$(document).ready(function () {
    $('.mega-menu__item-content ul li a').hover(function () {
        let imgId = $(this).data('img');

        // Remove 'active' from all images
        $('.mega-menu__img img').removeClass('active');

        // Add 'active' to the matching image
        $('.mega-menu__img img[data-img="' + imgId + '"]').addClass('active');
    });
});





// menu end



// cart-drawer start

$(".cart-drawer__gift-title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".cart-drawer__gift-note").slideUp();
    } else {
        $(".cart-drawer__gift-note").slideUp();
        $(".cart-drawer__gift-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".cart-drawer__gift-note").slideDown();
    }
})



$(".header__cart").on('click', function () {
    $("body").addClass("cart-open")
})
$(".cart-drawer__close,.overlay").on('click', function () {
    $("body").removeClass("cart-open")
})


document.addEventListener("DOMContentLoaded", function () {
    const overlay = document.querySelector(".overlay");
    const cartDrawer = document.querySelector(".cart-drawer");
    const openBtn = document.querySelector(".header__cart");
    const closeBtn = document.querySelector(".cart-drawer__close");

    openBtn.addEventListener("click", () => {
        overlay.classList.add("active");
    });

    closeBtn.addEventListener("click", () => {
        overlay.classList.remove("active");
    });

    // Optional: clicking outside the drawer also closes it
    // overlay.addEventListener("click", () => {
    //     const $search = $(".header__search");
    //     $search.css("height", "0").removeClass("open").css("z-index", "-1");
    //     overlay.classList.remove("active");
    // });

     overlay.addEventListener("click", () => {
        const $search = $(".header__search");

        if ($search.hasClass("open")) {
            $search.css("height", "0").removeClass("open");

            // Wait for transition before hiding with z-index
            $search.one("transitionend", function () {
                $search.css("z-index", "-1");
            });
        }

        overlay.classList.remove("active");
    });
});



// cart-drawer end




// journal dropdown start



document.querySelector(".journal__filter-select-selected").addEventListener("click", function () {
    this.classList.toggle("active");
    document.querySelector(".journal__filter-select-items").style.display =
        document.querySelector(".journal__filter-select-items").style.display === "block" ? "none" : "block";
});

document.querySelectorAll(".journal__filter-select-items li").forEach((item) => {
    item.addEventListener("click", function () {
        document.querySelector(".journal__filter-select-selected").innerText = this.innerText;
        document.querySelector(".journal__filter-select-items").style.display = "none";
    });
});

document.addEventListener("click", function (e) {
    const selectBox = document.querySelector(".journal__filter-select");
    if (!selectBox.contains(e.target)) {
        document.querySelector(".journal__filter-select-items").style.display = "none";
        document.querySelector(".journal__filter-select-selected").classList.remove("active");
    }
});



// journal dropdown end